import React from 'react';
import { cn } from '~/helpers/utils';

type ToolPanelFormGroupProps = {
  className?: string;
  children: React.ReactNode;
};

const ToolPanelFormGroup: React.FC<ToolPanelFormGroupProps> = ({ className, children }) => {
  return (
    <div className={cn('py-7 border-b-2 border-stone-50 last:border-0', className)}>
      {children}
    </div>
  );
};

export default ToolPanelFormGroup;